module.exports = __webpack_public_path__ + "static/uswithoxfordwaitresses-6665edc875ada6b6240b0f7ad883c631.jpg";